enum Status {
  'pending',
  'rejected',
  'approved',
}
const COLORS = {
  PENDING: '#3F90EC',
  APPROVED: '#5DD39E',
  REJECTED: '#E41B0C',
  STATELESS: '#7795A1',
}

const getStatusColor = (status: Status): string => {
  const statusColorMap = {
    pending: COLORS.PENDING,
    approved: COLORS.APPROVED,
    rejected: COLORS.REJECTED,
  }

  return statusColorMap[status] || COLORS.STATELESS
}

export const StatusWrapper = ({ children, status }) => (
  <div className="flex w-[345px] rounded-md bg-[#F6F8FA] overflow-hidden group">
    {children}
    <div
      className="w-[23px] opacity-30 group-hover:opacity-100 transition-opacity duration-200"
      style={{ backgroundColor: getStatusColor(status) }}
    />
  </div>
)
